import type { SVGProps } from "react";
// generated from Asterisk.svg — do not edit manually
// prettier-ignore
export default function Asterisk(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 12 4 V 20 M 18 6 L 6 18 M 20 12 H 4 M 18 18 L 6 6" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
